// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkUserRelationshipModal_link__1jbrp","helperText":"LinkUserRelationshipModal_helperText__ogOoC"};